import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../images/img_code.png'
import _imports_1 from '@/images/police.png'


const _withScopeId = n => (_pushScopeId("data-v-73efb7f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-view" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "paddingTop16" }, "联系我们", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "marginBot16 marginTop12",
  src: _imports_0
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44049202000346",
  style: {"display":"inline-block","text-decoration":"none"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    style: {"float":"left"}
  }),
  /*#__PURE__*/_createElementVNode("p", {
    style: {"float":"left","height":"20px"},
    class: "font-10"
  }, "粤公网安备 44049202000346号 ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-10" }, "©2021-2023 版权所有 珠海视塔软件有限公司", -1))


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterView',
  setup(__props) {

const linkTo = () => {
  window.open(`https://beian.miit.gov.cn/#/Integrated/index`);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "column-flex flex-center" }, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", { class: "ba" }, [
        _createElementVNode("span", {
          class: "font-10 pointer",
          onClick: linkTo
        }, "粤ICP备2023081704号"),
        _hoisted_4
      ]),
      _hoisted_5
    ])
  ]))
}
}

})